import { useFormikContext } from "formik";
import { Divider, Grid } from "@mui/material";
import { isExists } from "../../../utils";
import useLocales from "../../../hooks/useLocales";
import {
  AddressReferenceDropDown,
  CheckboxInput,
  ReferenceDropDown,
  TextInput,
} from "../../../components";

const CustomerAddressCreate = () => {
  const { translate } = useLocales();
  const formik: any = useFormikContext();
  return (
    <Grid container spacing={3}>
      <Grid item md={6}>
        <ReferenceDropDown
          name="address.addressDetail.addressTypeId"
          label={translate("resources.customers.addresses.address_type")}
          reference="fixity/customer/addressType"
          optionName="name"
          disabled={formik.values.isExistCustomer ? true : false}
        />
      </Grid>
      <Grid item md={6}>
        <TextInput
          name="address.detail"
          label={translate("resources.customers.addresses.address_detail")}
          rows={1}
          multiline
          disabled={formik.values.isExistCustomer}
        />
      </Grid>
      <Grid item md={12}>
        <Divider />
      </Grid>

      <Grid item md={6}>
        {formik.values.address.isForeign && (
          <AddressReferenceDropDown
            name="address.city"
            label={translate("resources.customers.addresses.city")}
            reference="fixity/setting/addressLocation/get-foreign-city"
            optionName="name"
            query={{
              parentNationalityId: formik.values.address.nationalityId,
            }}
            optionId="turkTelekomId"
            secondField={{
              name: "address.addressDetail.addressLocationId",
              value: "id",
            }}
            disabled={
              !isExists(formik.values.address.nationalityId) ||
              formik.values.isExistCustomer
            }
            skip={!isExists(formik.values.address.nationalityId)}
          />
        )}
        {!formik.values.address.isForeign && (
          <AddressReferenceDropDown
            name="address.city"
            label={translate("resources.customers.addresses.city")}
            reference="fixity/setting/TurkTelekomAddress/get-cities/187cf1ae-023f-ed11-a5f4-005056a2cd35"
            optionName="name"
            optionId="turkTelekomId"
            secondField={{
              name: "address.addressDetail.addressLocationId",
              value: "id",
            }}
            disabled={
              !isExists(formik.values.address.nationalityId) ||
              formik.values.isExistCustomer
            }
            skip={!isExists(formik.values.address.nationalityId)}
          />
        )}
      </Grid>
      <Grid item md={6}>
        <AddressReferenceDropDown
          name="address.town"
          label={translate("resources.customers.addresses.town")}
          reference={`fixity/setting/TurkTelekomAddress/get-towns-by-city-id`}
          query={{ cityId: formik?.values?.address?.city?.value }}
          optionName="name"
          optionId="turkTelekomId"
          secondField={{
            name: "address.addressDetail.addressLocationId",
            value: "id",
          }}
          disabled={
            !isExists(formik?.values?.address?.city) ||
            formik.values.isExistCustomer
          }
          skip={!isExists(formik?.values?.address?.city)}
        />
      </Grid>
      <Grid item md={6}>
        <AddressReferenceDropDown
          name="address.townShip"
          label={translate("resources.customers.addresses.townShip")}
          reference={`fixity/setting/TurkTelekomAddress/get-townships-by-town-id`}
          query={{ townId: formik?.values?.address?.town?.value }}
          optionName="name"
          optionId="turkTelekomId"
          secondField={{
            name: "address.addressDetail.addressLocationId",
            value: "id",
          }}
          disabled={
            !isExists(formik?.values?.address?.town) ||
            formik.values.isExistCustomer
          }
          skip={!isExists(formik?.values?.address?.town)}
        />
      </Grid>
      <Grid item md={6}>
        <AddressReferenceDropDown
          name="address.village"
          label={translate("resources.customers.addresses.village")}
          reference={`fixity/setting/TurkTelekomAddress/get-villages-by-township-id`}
          query={{ TownShipId: formik?.values?.address?.townShip?.value }}
          optionName="name"
          optionId="turkTelekomId"
          secondField={{
            name: "address.addressDetail.addressLocationId",
            value: "id",
          }}
          disabled={
            !isExists(formik?.values?.address?.townShip) ||
            formik.values.isExistCustomer
          }
          skip={!isExists(formik?.values?.address?.townShip)}
        />
      </Grid>
      <Grid item md={6}>
        <AddressReferenceDropDown
          name="address.district"
          label={translate("resources.customers.addresses.district")}
          reference={`fixity/setting/TurkTelekomAddress/get-districts-by-village-id`}
          query={{ VillageId: formik?.values?.address?.village?.value }}
          optionName="name"
          optionId="turkTelekomId"
          secondField={{
            name: "address.addressDetail.addressLocationId",
            value: "id",
          }}
          disabled={
            !isExists(formik?.values?.address?.village) ||
            formik.values.isExistCustomer
          }
          skip={!isExists(formik?.values?.address?.village)}
        />
      </Grid>
      <Grid item md={6}>
        <AddressReferenceDropDown
          name="address.street"
          label={translate("resources.customers.addresses.street")}
          reference={`fixity/setting/TurkTelekomAddress/get-streets-by-district-id`}
          query={{ districtId: formik?.values?.address?.district?.value }}
          optionName="name"
          optionId="turkTelekomId"
          secondField={{
            name: "address.addressDetail.addressLocationId",
            value: "id",
          }}
          disabled={
            !isExists(formik?.values?.address?.district) ||
            formik.values.isExistCustomer
          }
          skip={!isExists(formik?.values?.address?.district)}
        />
      </Grid>

      {formik?.values?.address?.addressDetail?.adressNotFound ? (
        <Grid item md={4}>
          <TextInput
            name="address.addressDetail.buildingNumber"
            label={translate("resources.customers.addresses.building")}
            disabled={
              !isExists(formik?.values?.address?.street) ||
              formik.values.isExistCustomer
            }
          />
        </Grid>
      ) : (
        <Grid item md={4}>
          <AddressReferenceDropDown
            name="address.building"
            label={translate("resources.customers.addresses.building")}
            reference={`fixity/setting/TurkTelekomAddress/get-building-numbers-by-street-id`}
            query={{ StreetId: formik?.values?.address?.street?.value }}
            optionName="name"
            optionId="turkTelekomId"
            secondField={{
              name: "address.addressDetail.addressLocationId",
              value: "id",
            }}
            disabled={
              !isExists(formik?.values?.address?.street) ||
              formik.values.isExistCustomer
            }
            skip={!isExists(formik?.values?.address?.street)}
          />
        </Grid>
      )}
      <Grid item md={2}>
        <CheckboxInput
          name="address.addressDetail.adressNotFound"
          label={translate("resources.customers.addresses.adressNotFound")}
          disabled={formik.values.isExistCustomer}
        />
      </Grid>
      {formik?.values?.address?.addressDetail?.adressNotFound ? (
        <Grid item md={6}>
          <TextInput
            name="address.addressDetail.doorNumber"
            label={translate("resources.customers.addresses.door")}
            disabled={
              !isExists(
                formik?.values?.address?.addressDetail?.buildingNumber ||
                  formik?.values?.address?.building?.value
              ) || formik.values.isExistCustomer
            }
          />
        </Grid>
      ) : (
        <Grid item md={6}>
          <AddressReferenceDropDown
            name="address.door"
            label={translate("resources.customers.addresses.door")}
            reference={`fixity/setting/TurkTelekomAddress/get-door-numbers-by-building-id`}
            query={{ BuildingId: formik?.values?.address?.building?.value }}
            optionName="name"
            optionId="turkTelekomId"
            secondField={{
              name: "address.addressDetail.addressLocationId",
              value: "id",
            }}
            disabled={
              !isExists(formik?.values?.address?.building) ||
              formik.values.isExistCustomer
            }
            skip={!isExists(formik?.values?.address?.building)}
          />
        </Grid>
      )}
      {/* {!formik.values.address.isForeign && (
        <>
          
          
          
          
          

          
          
          
        </>
      )} */}
    </Grid>
  );
};

export default CustomerAddressCreate;
